module.exports = __webpack_public_path__ + "img/abi.bdaaf796.png";